import { useErrorMessage } from '@/shared/i18n';

import styles from './FormError.module.css';

/** Form-level error banner for errors not tied to a field. */
export function FormError({ error }: { error: unknown }) {
  const getMessage = useErrorMessage();
  if (!error) return null;
  return (
    <p className={styles.error} role="alert">
      {getMessage(error)}
    </p>
  );
}
